import Rails from '@rails/ujs'
import ReactRailsUJS from 'react_ujs'

import airbrake from 'shared/airbrake'

Rails.start()
ReactRailsUJS.useContexts([
  require.context("landing_pages/components", true, /\/LandingPage$/),
]);

window.airbrake = airbrake;
